import { createContext } from "react";

import { type EntityHistoryModalProps } from "@/components/modals";

export type ShowHistoryParams<T extends Record<string, unknown> = Record<string, unknown>> = {
	entityType: string;
	entityId: string;
} & Omit<EntityHistoryModalProps<T>, "entityHistoryUrl" | "onClose">;

interface EntityHistoryContextProps {
	closeHistory: () => void;
	showHistory: <T extends Record<string, unknown> = Record<string, unknown>>(params: ShowHistoryParams<T>) => void;
}

export const initialProps: EntityHistoryContextProps = {
	closeHistory: () => undefined,
	showHistory: () => undefined,
};

export const EntityHistoryContext = createContext<EntityHistoryContextProps>(initialProps);
